import { Label } from ".";
import { classNames, formatCurrency } from "../../utils/helpers";
import {clsx} from "clsx";

export default function NumberInput({
  label,
  subLabel,
  name,
  placeholder = "",
  required = false,
  value,
  min,
  max,
  onChange,
  className,
  onFocus,
  onBlur,
  id,
  isCurrency,
  isPennies
}) {
  return (
    <>
      {/* Label/required asterisk */}
      {label && <Label label={label} required={required} />}
      <div className={classNames("flex relative", label ? "mt-1" : "")}>
        {/* Input */}
        <input
            id={id}
          type="number"
          name={name}
          className={clsx(className,
            "p-2 focus:outline-none block w-full sm:text-sm border border-gray-200 placeholder-gray-300",
            !!isCurrency ? "rounded-s-md" :  "rounded-md"
          )}
          placeholder={placeholder}
          required={required}
          value={value}
          min={min}
          max={max}
          onFocus={onFocus}
          onBlur={onBlur}
          onChange={onChange}
          readOnly={!onChange}
          autoComplete="off"
        />
        {!!isCurrency && !!value && (<div className="flex text-gray-500 p-2 bg-white rounded-e-md border-e border-y border-gray-200">{formatCurrency(value, isPennies)}</div>)}
      </div>
      {/* Sublabel */}
      {subLabel && (
        <div className="mt-1 text-gray-400 text-xs text-right">{subLabel}</div>
      )}
    </>
  );
}
